const ru = {
    general: {
        open: 'Открыть',
        close: 'Закрыть',
        clear: 'Очистить',
        reset: 'Сбросить',
        error: 'Непредвиденная ошибка',
        empty: 'Совпадений не найдено',
        signin: 'Войти',
        signup: 'Регистрация',
    },
    primitives: {
        Actions: {
            accept: 'Принять',
            cancel: 'Отмена',
            selected: 'Выбрано значений:',
        },
        Pagination: {
            prev: 'Предыдущие',
            next: 'Следующие',
            jumpto: 'на страницу',
        },
    },
    components: {
        Status: {
            button: 'На главную',
            phone: 'Телефон',
            schedule: 'График работы: c 9:00 до 21:00 без выходных',
            Forbidden: {
                title: 'Недостаточно прав',
                description: 'Чтобы получить доступ, обратитесь в поддержку',
            },
            NotFound: {
                title: 'Страница не найдена',
                description: 'Попробуйте другую ссылку или вернитесь на главную страницу',
            },
            InternalServerError: {
                title: 'Технические работы',
                description: 'Страница может быть недоступна некоторое время — попробуйте зайти через несколько минут',
            },
        },
        ActionsButton: {
            button: 'Действия',
        },
        Filters: {
            title: 'Фильтрация таблицы',
            reset: 'Сбросить все фильтры',
        },
        ColumnsSettings: {
            title: 'Настройка таблицы',
            reset: 'Сбросить по умолчанию',
        },
    },
    features: {
        Table: {
            filter: 'Фильтрация',
            sorter: 'Сортировка',
            ascending: 'По возрастанию',
            descending: 'По убыванию',
            hide: 'Скрыть',
            pin: 'Закрепить',
            unpin: 'Открепить',
            column: 'Колонка',
            reset: 'Сбросить',
            settings: 'Настройки',
        },
    },
    widgets: {
        Layout: {
            Header: {
                analytics: 'Аналитика',
                support: 'Поддержка',
                info: 'Инструкции',
            },
            Apps: {
                title: 'Все сервисы',
                all: 'Смотреть все',
            },
            Profile: {
                profile: 'Профиль в S.Team',
                logout: 'Выйти',
            },
        },
    },
};

export { ru };
//# sourceMappingURL=ru.js.map
